export class DbNoConnectionError extends Error{
  constructor(
    text: string
  ) {
    super(text)
  }
}
